﻿
export interface IMapping<KeyType, ValueType> {
    key: KeyType;
    value: ValueType;
}

export class Map<KeyType, ValueType> {
    private _data: IMapping<KeyType, ValueType>[] = [];

    public set(key: KeyType, value: ValueType) {
        let existingValue = this.getItem(key);
        if (existingValue) {
            existingValue.value = value;
        }
        this._data.push({
            key,
            value
        });
    }

    public get(key: KeyType): ValueType {
        let mapping = this.getItem(key);
        if (!mapping) return null;
        return mapping.value;
    }

    public delete(key: KeyType) {
        this._data.removeWhere(d => d.key == key);
    }

    private getItem(key: KeyType): IMapping<KeyType, ValueType> {
        return this._data.find(d => d.key == key);
    }
}
